window.initCouponCarousel = function (sectionId) {
  var track = document.getElementById('couponTrack-' + sectionId);
  var dotsWrap = document.getElementById('couponDots-' + sectionId);
  if (!track) return;

  var section = track.closest('.coupon-carousel');
  var cards = Array.prototype.slice.call(track.querySelectorAll('.coupon-card'));
  var prevBtn = section.querySelector('.coupon-carousel__arrow--prev');
  var nextBtn = section.querySelector('.coupon-carousel__arrow--next');

  // Copy-to-clipboard
  track.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-code]');
    if (!btn || btn.disabled) return;
    var code = btn.getAttribute('data-copy-code');

    var doCopyFeedback = function () {
      btn.classList.add('is-copied');
      setTimeout(function () { btn.classList.remove('is-copied'); }, 1800);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(doCopyFeedback).catch(function () {
        fallbackCopy(code);
        doCopyFeedback();
      });
    } else {
      fallbackCopy(code);
      doCopyFeedback();
    }
  });

  function fallbackCopy(text) {
    var temp = document.createElement('textarea');
    temp.value = text;
    temp.style.position = 'fixed';
    temp.style.opacity = '0';
    document.body.appendChild(temp);
    temp.select();
    try { document.execCommand('copy'); } catch (err) {}
    document.body.removeChild(temp);
  }

  // Dots — one per visible "page" based on how many cards fit
  function cardsPerView() {
    if (!cards.length) return 1;
    var trackWidth = track.clientWidth;
    var cardWidth = cards[0].getBoundingClientRect().width + 24; // gap
    return Math.max(1, Math.round(trackWidth / cardWidth));
  }

  function buildDots() {
    dotsWrap.innerHTML = '';
    var perView = cardsPerView();
    var pageCount = Math.max(1, Math.ceil(cards.length / perView));
    for (var i = 0; i < pageCount; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'coupon-carousel__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function (idx) {
        return function () {
          var perView2 = cardsPerView();
          var targetCard = cards[idx * perView2];
          if (targetCard) {
            track.scrollTo({ left: targetCard.offsetLeft, behavior: 'smooth' });
          }
        };
      }(i));
      dotsWrap.appendChild(dot);
    }
    updateActiveDot();
  }

  function updateActiveDot() {
    var perView = cardsPerView();
    var index = Math.round(track.scrollLeft / (cards[0] ? (cards[0].getBoundingClientRect().width + 24) : 1) / perView);
    var dots = dotsWrap.querySelectorAll('.coupon-carousel__dot');
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
    if (nextBtn) nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });
  }

  track.addEventListener('scroll', debounce(updateActiveDot, 80));
  window.addEventListener('resize', debounce(buildDots, 150));

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  buildDots();
};